export default {
    midConfig: {
        orgId: 'EA673DFC5A2F19060A495C9C@AdobeOrg',
        cookieKeyPre: 'AMCV_',
        enableMid: true,
        demdexCallEnable: true,
        serviceTimeout: 500,
        serviceUrl: 'https://dpm.demdex.net/id',
        audienceManagerServer: 'dpm.demdex.net',
        audienceManagerServerSecure: 'true',
        version: '3.0.0',
        MCMID: "MCMID",
    },
    svcEndpoint: '/events/analytics/public/v1/cc.gif',
    javaScriptVer: '1.8.5',
    visitorIdKey: 'v1st',
    smSessionKey: 'SMSESSION',
    serviceConfig: {
        'analytics.mid.create.svc': {
            settings: {
                url: 'https://dpm.demdex.net/id',
                method: 'GET',
                dataType: 'json',
                disableTrace: true,
                disableDefaultError: true,
                disableOfflineHandler: true
            }
        }
    }
};
